import React from 'react'
import CustomSelect from 'src/components/CustomComponents/CustomSelect'
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect'

export const BOOK_CATEGORY_OPTIONS = [
	{ label: 'Self-Growth', value: 'Self-Growth' },
	{ label: 'Conversation', value: 'Conversation' },
	{ label: 'Fiction', value: 'Fiction' },
	{ label: 'Non Fiction', value: 'Non Fiction' },
	{ label: 'Classics', value: 'Classics' },
	{ label: 'Moral-Stories', value: 'Moral-Stories' },
	{ label: 'Thriller', value: 'Thriller' },
]

interface BookCategoryProps {
	multiple?: boolean
	includeAll?: boolean
	includeAllLabel?: string
	value: string | null | string[]
	onChange: ((value: string | null) => void) | ((value: string[]) => void)
	sx?: any
	placeholder?: string
}

function BookCategory({
	multiple = false,
	includeAll = false,
	includeAllLabel = 'All',
	value,
	onChange,
	sx,
	placeholder = 'Category',
}: BookCategoryProps) {
	const categoryOptionsWithAll = [
		{ label: includeAllLabel, value: null },
		...BOOK_CATEGORY_OPTIONS,
	]

	if (multiple) {
		return (
			<CustomMultiSelect
				value={Array.isArray(value) ? value : []}
				data={BOOK_CATEGORY_OPTIONS}
				onChange={onChange as (value: string[]) => void}
				placeholder={placeholder}
				sx={sx}
			/>
		)
	}

	return (
		<CustomSelect
			value={!Array.isArray(value) ? value : null}
			data={includeAll ? categoryOptionsWithAll : BOOK_CATEGORY_OPTIONS}
			onChange={onChange as (value: string | null) => void}
			placeholder={placeholder}
			sx={sx}
		/>
	)
}

export default React.memo(BookCategory)
